import {addQueryParamsToURL} from '../../utils/url'

export function transformBuildigoImageUrl(
  imageSrc: string,
  args?: {width?: number; height?: number; format?: 'avif' | 'webp'},
): string {
  // the buildigo image API will use `accept` headers to determine the best image format
  // for a given browser, therefore there's no need to explicitly request for avif or webp
  const parameters: Record<string, string | number> = {
    ...(args?.width ? {w: args.width} : {}),
    ...(args?.height ? {h: args.height} : {}),
    ...(args?.format ? {fmt: args.format} : {}),
  }
  return addQueryParamsToURL(imageSrc, parameters)
}
